import { Card, CardActions, CardContent, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledCard = styled(Card)(({ theme }) => {
  return {
    '&.MuiCard-root': {
      display: 'flex',
      flexDirection: 'column',
      minWidth: 170,
      minHeight: 390,
      padding: theme.spacing(2),
      boxShadow: `0px 0px 0px 1px ${theme.palette.grey[300]}`,
      borderRadius: 8,
    },
    '& > div > div': {
      padding: 0,
    },
  };
});

export const CardMediaWrapper = styled(Stack)(({ theme }) => {
  return {
    justifyContent: 'center',
    alignSelf: 'center',
    width: 180,
    paddingRight: 0,
    marginBottom: theme.spacing(2),
  };
});

export const StyledCardContent = styled(CardContent)(({ theme }) => ({
  flex: 1,
  marginTop: theme.spacing(2),
}));

export const StyledCardActions = styled(CardActions)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
  marginTop: theme.spacing(2),
  '& > *': {
    flex: 1,
  },
}));
